import {
  isRunRefused,
  type CardActionHandlers,
} from '@littlebird/action-cards-view';

// How a run press ended: the run resolved, the server refused it, or the call threw. A run that resolved includes one
// that failed or still ran when the host stopped waiting; the card shows which
export type RunEnd = 'settled' | 'refused' | 'threw';

export type RunEvents = {
  // Called when a run is pressed, before it starts, so a host can keep the card in view
  onRun?: () => void;
  // Called once a run resolves without a refusal
  onRunSettled?: () => void;
  // Called once a run press ends, however it ended
  onRunEnd?: (end: RunEnd) => void;
};

export const withRunEvents = (
  handlers: CardActionHandlers,
  { onRun, onRunSettled, onRunEnd }: RunEvents
): CardActionHandlers => ({
  ...handlers,
  acknowledge: async () => {
    onRun?.();
    let end: RunEnd = 'threw';
    try {
      await handlers.acknowledge();
      end = 'settled';
      onRunSettled?.();
    } finally {
      onRunEnd?.(end);
    }
  },
  run: async (key, seenSyncId) => {
    onRun?.();
    let end: RunEnd = 'threw';
    try {
      const outcome = await handlers.run(key, seenSyncId);
      end = isRunRefused(outcome) ? 'refused' : 'settled';
      if (end === 'settled') onRunSettled?.();
      return outcome;
    } finally {
      onRunEnd?.(end);
    }
  },
});
